import { logger as LOG } from '@sweetgreen/garnish';

export const mixpanelLogger = LOG.extend('Mixpanel');

LOG.disable('Mixpanel');
